import { render, staticRenderFns } from "./ShareTwitter.vue?vue&type=template&id=2ae0d804&scoped=true&"
import script from "./ShareTwitter.vue?vue&type=script&lang=ts&"
export * from "./ShareTwitter.vue?vue&type=script&lang=ts&"
import style0 from "./ShareTwitter.vue?vue&type=style&index=0&id=2ae0d804&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae0d804",
  null
  
)

export default component.exports